import { Dispatch, PropsWithChildren, createContext, useContext, useReducer } from 'react';
import { ReducerAction } from './actions';
import { reducer } from './reducer';
export type GlobalContextType = {
    handleCaseSave: ((shoudNavigate: boolean) => void | Promise<void>) | null;
};
export const initialGlobalContext: GlobalContextType = {
    handleCaseSave: null
};

const GlobalContext = createContext<GlobalContextType>(initialGlobalContext);
const GlobalContextDispatch = createContext<Dispatch<ReducerAction>>(() => ({}));

function useGlobalContext() {
    const context = useContext(GlobalContext);
    if (!context) throw new Error('useGlobalContext must be used in GlobalContextProvider');
    return context;
}
function useGlobalContextDispatch() {
    const context = useContext(GlobalContextDispatch);
    if (!context) throw new Error('useGlobalContextDispatch must be used in GlobalContextProvider');
    return context;
}
const GlobalContextProvider = ({ children }: PropsWithChildren) => {
    const [state, dispatch] = useReducer(reducer, initialGlobalContext);
    return (
        <GlobalContext.Provider value={state}>
            <GlobalContextDispatch.Provider value={dispatch}>
                {children}
            </GlobalContextDispatch.Provider>
        </GlobalContext.Provider>
    );
};
export { useGlobalContext, useGlobalContextDispatch };
export default GlobalContextProvider;
